'use strict';

// load jQuery Scrollbar
basecoat.jQueryScrollbar = require('script-loader!jquery.scrollbar/jquery.scrollbar');

+function ($) {

  $.fn.jQueryScrollbar = $.fn.scrollbar;
  $.fn.scrollbar = function () {
    return this
    .find('.scrollbars')
    .addBack('.scrollbars')
    .each(function () {
      $(this)
      .addClass('scrollbar-inner')
      .jQueryScrollbar({
        // debug: true,
        ignoreMobile: false, // use the mobile's native scrollbar functionality instead of this plugin
        disableBodyScroll: !($(this).data('disable-body-scroll') == false), // disable entire page scrolling if the mouse is over the container
        //callback function before scrollbars size is calculated
        onUpdate: function ($element) {
          if (parseInt($element.css('maxHeight'), 10) < 30) {
            // fix to initialize scrollbars inside of hidden modals and drop-downs BEFORE they open on the screen.
            // jQueryScrollbar plugin sets maxHeight = scrollbar-height on invisible targets and it causes a delayed redraw of the scrollbars on opening, so we just have to undo it.
            $element.css('maxHeight', '');
          }
        }
      });
    });
  };

  $(document)
  // prevent unexpected events firing on click of a scrollbar
  .on('click.bc.scrollbar', '.scroll-element', function (e) {
    e.stopPropagation();
  });

  // postInit ensures that everything else has run before scrollbars are attached
  basecoat.postInit.scrollbar = function () {
    $(this).scrollbar();
  };

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/scrollbar.js
// module id = 15
// module chunks = 0